export const getFacetedSearchStyles = ({ css }: any) => css`
  :focus {
    outline: transparent !important;
  }
`;

export const getUserCasesStyles = ({ css }: any) => css`
  :focus {
    outline: transparent !important;
  }
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
`;
